import axios from 'axios'
import store from '../vuex/store'
import Vue from "vue"; // vuex 저장소 추가
import appConfig from "@/config/app.config.json"
import apiHost from "@/config/api.hosts.json"

export const getApiHost = () => {
    if (appConfig.build == "local") { 
        return apiHost.host.api.local 
    } else if (appConfig.build == "prod") {
        return apiHost.host.api.prod
    } else if (appConfig.build == "test") {
        return apiHost.host.api.test
    } else if (appConfig.build == "us-prod") {
        return apiHost.host.api.usProd
    } else if (appConfig.build == "us-test") {
        return apiHost.host.api.usTest
    } else {
        return apiHost.host.api.test
    }
}

export const getFileHost = () => {
    if (appConfig.build == "local") { 
        return apiHost.host.file.local 
    } else if (appConfig.build == "prod") {
        return apiHost.host.file.prod
    } else if (appConfig.build == "test") {
        return apiHost.host.file.test
    } else if (appConfig.build == "us-prod") {
        return apiHost.host.file.usProd
    } else if (appConfig.build == "us-test") {
        return apiHost.host.file.usTest
    } else {
        return apiHost.host.file.test
    }
}

export const resourceHost = getApiHost();
export const fileHost = getFileHost();

//API request
export const request = async (parameters) => {
    try {
        let params = {}
        if (parameters.params) {
            params = parameters.params
        }
        params.t = new Date().getTime()

        const response = await axios({
            method: parameters.method,
            cache: false,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Cache-Control': 'no-cache',
            },
            url: resourceHost + parameters.path,
            params: params,
        })
        return response
    } catch (error) {
		if (error.response.status == 403) {
            store.dispatch('logoutToLogin')
        }
        return error.response
    }
}

export const download = async (parameters) => {
    try {
        let params = {}
        if (parameters.params) {
            params = parameters.params
        }
        params.t = new Date().getTime()

        const response = await axios({
            method: parameters.method,
            cache: false,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Cache-Control': 'no-cache',
            },
            url: fileHost + parameters.path,
            params: params,
        })
        return response
    } catch (error) {
        if (error.response.status == 403) {
            store.dispatch('logoutToLogin')
        }
        return error.response
    }
}

export const fileUploadRequest = async (parameters) => {
    try {
        let params = {}
        if (parameters.params) {
            params = parameters.params
        }
        params.t = new Date().getTime()

        const response = await axios({
            data: parameters.data ? parameters.data : null,
            cache: false,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'multipart/form-data',
                'Cache-Control': 'no-cache',
            },
            method: parameters.method,
            url: fileHost + parameters.path,
            params: params,
            crossdomain: true,
            timeout: 1800000 //30분
        })
        return response
    } catch (error) {
        return error.response
    }
}

export const formDataRequest = async (parameters) => {
    try {
        let params = {}
        if (parameters.params) {
            params = parameters.params
        }
        params.t = new Date().getTime()

        const response = await axios({
            data: parameters.data ? parameters.data : null,
            cache: false,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Cache-Control': 'no-cache',
            },
            method: parameters.method,
            url: resourceHost + parameters.path,
            params: params,
            crossdomain: true,
            timeout: 1800000 //30분
        })
        return response
    } catch (error) {
        return error.response
    }
}

export const downloadLocalFile = (fileurl, filename) => {
    axios({
        url: fileurl,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
    });
}



// WEBPACK FOOTER //
// ./src/service/API.js